import { forwardRef, rem, Stack, StackProps } from '@bonusly/design-system';

export const Section = forwardRef<StackProps, 'section'>(({ children, ...rest }: StackProps, ref) => {
	return (
		<Stack as="section" bg="bg.surface" borderRadius="lg" gap={4} w={rem(560)} px={10} py={6} ref={ref} {...rest}>
			{children}
		</Stack>
	);
});

Section.displayName = 'Section';
